<template>
  <div v-if="item" class="bg-gray bs-low p-4" ref="orderBlock" id="orderBlock">
    <div class="data-card__header flex-wrap">
      <h2 class="m-0">№{{ item.number }}</h2>
      <div v-if="$isAccess($userRoles.Admin, $userRoles.Specialist, $userRoles.Dispatcher) && $user.workWithOrdersAccess">
        <el-button v-if="isEdited" type="primary" size="medium" @click="onSave" :loading="updateProgress">Сохранить</el-button>
        <el-button v-else size="medium" @click="isEdited=true">Изменить</el-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6 col-xxl-4 mt-4">
        <OrderCard :isEdited="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" ref="orderCard" />
      </div>
      <div class="col-12 col-lg-6 col-xxl-4 mt-4">
        <ClientCard :isEdited="isEdited && $isAccess($userRoles.Admin)" ref="clientCard" />
      </div>
      <div class="col-12 col-lg-6 col-xxl-4 mt-4">
        <WorkerCard :isEdited="isEdited" ref="workerCard" />
      </div>
      <div v-if="item.orderRows.length" class="col-12 mt-4">
        <OrderRowsCard :isEdited="isEdited" ref="orderRowsCard" />
      </div>
      <div v-if="item.service" class="col-12 col-xl-6 mt-4">
        <StepsCard />
      </div>
      <div v-if="item.claimData" class="col-12 col-xl-6 mt-4">
        <ClaimCard />
      </div>
      <div v-if="item.cancellationData" class="col-12 col-xl-6 mt-4">
        <CancellationCard />
      </div>
      <div v-if="item.status.code === ORDER_STATUS_CODES.WASTED_VISIT" class="col-12 col-xl-6 mt-4">
        <WastedVisitCard />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ORDER_STATUS_CODES } from '@/commons/constants/orderStatusCodes';
import OrderCard from '@/components/orders/OrderCard';
import ClientCard from '@/components/orders/ClientCard';
import OrderRowsCard from '@/components/orders/OrderRowsCard';
import WorkerCard from '@/components/orders/WorkerCard';
import StepsCard from '@/components/orders/StepsCard';
import ClaimCard from '@/components/orders/ClaimCard';
import CancellationCard from '@/components/orders/CancellationCard';
import WastedVisitCard from '@/components/orders/WastedVisitCard';

export default {
  components: {
    OrderCard,
    ClientCard,
    OrderRowsCard,
    WorkerCard,
    StepsCard,
    ClaimCard,
    CancellationCard,
    WastedVisitCard,
  },
  data: () => ({
    isEdited: false,
    ORDER_STATUS_CODES,
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
    }),
  },
  methods: {
    ...mapActions({
      updateOrder: 'orders/updateItem',
    }),
    onSave() {
      let data = {};

      const refs = ['orderCard', 'clientCard', 'workerCard'/* , 'orderRowsCard' */];
      const isValid = refs.every((ref) => {
        const { isValid, form } = this.$refs[ref].onSave();
        if (isValid) {
          data = { ...data, ...form };
        }
        return isValid;
      });

      if (!isValid) return;
      this.updateOrder({ id: this.item.id, data })
        .then(() => {
          this.isEdited = false;
        });
    },
  },
  watch: {
    item() {
      this.isEdited = false;

      // для скролла к одному заказу
      // if (newVal && !this.fetchProgress) {
      //   this.$nextTick(() => {
      //     this.$refs.orderBlock.scrollIntoView({ block: 'start', behavior: 'smooth' });
      //   });
      // }
    },
  },
};
</script>
